import {
  CustomerUserConfigLayoutTypesAndArrangements,
  ProtectedCustomerUserConfigTradingLayoutArrangements,
  type CustomerUserConfigLayoutType,
} from '@talos/kyoko';

export type LayoutArrangementOption = {
  label: string;
  value: string;
};

function isProtectedArrangement(key: string): boolean {
  return (
    ProtectedCustomerUserConfigTradingLayoutArrangements[
      key as keyof typeof ProtectedCustomerUserConfigTradingLayoutArrangements
    ] != null
  );
}

export function getLayoutArrangementOptions(layout: CustomerUserConfigLayoutType): LayoutArrangementOption[] {
  const arrangements = CustomerUserConfigLayoutTypesAndArrangements.get(layout);
  if (!arrangements) {
    return [];
  }
  return Object.keys(arrangements)
    .filter(key => !isProtectedArrangement(key))
    .map(key => ({
      value: key,
      label: key,
    }));
}

export function isArrangementValidForLayout(
  layout: CustomerUserConfigLayoutType,
  arrangement: string | undefined
): boolean {
  if (!arrangement) {
    return true;
  }
  if (isProtectedArrangement(arrangement)) {
    return false;
  }
  const arrangements = CustomerUserConfigLayoutTypesAndArrangements.get(layout);
  return arrangements != null && arrangement in arrangements;
}
